import { render, staticRenderFns } from "./FichaPapa.vue?vue&type=template&id=50ac9718&"
import script from "./FichaPapa.vue?vue&type=script&lang=js&"
export * from "./FichaPapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports